var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"selector",attrs:{"value":_vm.selectedNamespace,"items":_vm.namespaces,"item-text":"name","item-value":"name","label":_vm.$t('select-namespace'),"persistent-hint":"","return-object":""},on:{"change":_vm.selectNamespace}})
}
var staticRenderFns = []

export { render, staticRenderFns }